import React, {useState} from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import {Typography} from 'src/styles';
import {useStyle} from 'src/providers/style';
import PaperMenu from 'src/design-system/paper-menu';

const BehaviorProgramTooltip = ({name}: any) => {
  const styles = useStyle();
  const [visible, setVisible] = useState(false);

  return (
    <View style={styles.flex}>
      <PaperMenu
        visible={visible}
        onDismiss={() => setVisible(false)}
        anchor={
          <TouchableOpacity onPress={() => setVisible(!visible)}>
            <Text
              style={[Typography.P2_BOLD, styles.textColorWhite]}
              numberOfLines={1}
              ellipsizeMode="tail">
              {name}
            </Text>
          </TouchableOpacity>
        }>
        <View style={[styles.padding]}>
          <Text style={Typography.CAPTION}>{name}</Text>
        </View>
      </PaperMenu>
    </View>
  );
};

export default BehaviorProgramTooltip;
